import { useState, ReactNode, useContext, createContext } from 'react';

interface SelectedChatInfo {
  userId: number;
  userName: string;
  userRole?: string;
  userImageUrl?: string;
  chatId: number | string;
}

interface RealTimeChatContextType {
  isChatOpen: boolean;
  selectedChat: SelectedChatInfo | null;
  setIsChatOpen: (open: boolean) => void;
  setSelectedChat: (chat: SelectedChatInfo | null) => void;
}

export const RealTimeChatContext = createContext<
  RealTimeChatContextType | undefined
>(undefined);

export const RealTimeChatProvider = ({ children }: { children: ReactNode }) => {
  const [selectedChat, setSelectedChat] = useState<SelectedChatInfo | null>(
    null
  );
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <RealTimeChatContext.Provider
      value={{
        isChatOpen,
        selectedChat,
        setIsChatOpen,
        setSelectedChat,
      }}
    >
      {children}
    </RealTimeChatContext.Provider>
  );
};

export const useRealTimeChat = () => {
  const context = useContext(RealTimeChatContext);
  if (!context) {
    throw new Error('useRealTimeChat must be used within RealTimeChatProvider');
  }
  return context;
};
